// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterList_root__4sV61","item":"FooterList_item__3wmlt","columnOnSmall":"FooterList_columnOnSmall__1PLPb"};